export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/es/index.js
// module id = 1509
// module chunks = 3